export default __webpack_public_path__ + "static/section_4_details_12-53e8a2c09a53d6b8a238c2b7043820a2.png";